import React, { useState, useEffect, useRef } from 'react';
import { TreeSelect } from 'clad';
import treeSelectTopicFieldModel from './model/topicFieldModel';

const { TreeNode } = TreeSelect;

export const TreeSelectTopicField = React.forwardRef((props, ref) => {
    const { dataset, value, onChange } = props;
    const fieldsInfo = {};

    const parseValues =
        value &&
        value.map(value => {
            if (value.categoryName) {
                return `${value.categoryName} : ${value.nameField} [${
                    value.idField
                }]`;
            }
            return value.fieldletName;
        });

    const isMounted = useRef(null);
    const [data, setData] = useState({
        data: null,
        count: null,
        loading: null,
        loaded: false
    });

    const parents = {};
    let treeData = [];

    if (data.data) {
        data.data.forEach(row => {
            const title = (
                <div>
                    <p style={{ fontSize: '14px', fontWeight: 600 }}>
                        {row.id_field + ' -> '}
                        <span style={{ fontSize: '11px' }}>
                            {row.fieldlet_name}
                        </span>
                    </p>
                </div>
            );
            if (parents[row.category_name]) {
                parents[row.category_name].push(
                    <TreeNode
                        value={row.fieldlet_name}
                        title={title}
                        key={row.id_field}
                    />
                );
            } else {
                parents[row.category_name] = [];
                parents[row.category_name].push(
                    <TreeNode
                        value={row.fieldlet_name}
                        title={title}
                        key={row.id_field}
                    />
                );
            }

            fieldsInfo[row.id_field] = {
                ...row
            };
        });

        treeData = Object.keys(parents).map(parent => {
            return (
                <TreeNode
                    value={parent}
                    title={parent}
                    key={parent}
                    checkable={false}
                >
                    {parents[parent]}
                </TreeNode>
            );
        });
    }

    const handleChange = (value, opt, extra) => {
        if (extra.allCheckedNodes && extra.allCheckedNodes.length) {
            const newValues = extra.allCheckedNodes.map(checkedNode => {
                const node = checkedNode.node ? checkedNode.node : checkedNode;
                return {
                    idField: fieldsInfo[node.key].id_field,
                    nameField: fieldsInfo[node.key].name_field,
                    categoryName: fieldsInfo[node.key].category_name
                };
            });

            if (onChange) {
                onChange(newValues);
            }
        } else {
            if (onChange) {
                onChange([]);
            }
        }
    };

    const handleFetch = async () => {
        setData({
            ...data,
            loading: true
        });

        let result;

        if (dataset) {
            result = dataset;
        } else {
            result = await treeSelectTopicFieldModel.listTopicField();
        }

        setData({
            ...result,
            loading: false,
            loaded: true
        });
    };

    useEffect(() => {
        isMounted.current = true;
        handleFetch();
        return () => {
            isMounted.current = false;
        };
    }, []);

    return (
        <TreeSelect
            style={{ width: '100%' }}
            value={data.loading ? undefined : parseValues}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder={data.loading ? _('Loading...') : 'Please select'}
            allowClear
            treeCheckable
            onChange={handleChange}
            multiple
        >
            {treeData}
        </TreeSelect>
    );
});
